
;
                (function(){
                    const Func = (function() {
                        if(this.settings.layout==="slider"){let t=this.$el;if(!t)return;let i=t.querySelector(".ecom-shopify__blog-container"),o=i&&i.dataset.optionSwiper;o=JSON.parse(o),o.pagination={el:t.querySelector(".ecom-swiper-pagination"),type:"bullets",clickable:!0},o.navigation={nextEl:t.querySelector(".ecom-swiper-button-next"),prevEl:t.querySelector(".ecom-swiper-button-prev")},new window.EComSwiper(i,o)}
                    
                    });
                    const settings = {"layout":"slider"};
                    const ID = 'ecom-8j0c1bwklb3';
                    document.querySelectorAll('.ecom-8j0c1bwklb3').forEach(function(el){
                        Func.call({$el: el, settings, id:ID,isLive: true});
                    });
                })();
            
                (function(){
                    const Func = (function() {
                        if(this.settings.layout==="slider"){let t=this.$el;if(!t)return;let i=t.querySelector(".ecom-shopify__blog-container"),o=i&&i.dataset.optionSwiper;o=JSON.parse(o),o.pagination={el:t.querySelector(".ecom-swiper-pagination"),type:"bullets",clickable:!0},o.navigation={nextEl:t.querySelector(".ecom-swiper-button-next"),prevEl:t.querySelector(".ecom-swiper-button-prev")},new window.EComSwiper(i,o)}
                    
                    });
                    const settings = {"layout":"grid"};
                    const ID = 'ecom-wwcvdwv57z';
                    document.querySelectorAll('.ecom-wwcvdwv57z').forEach(function(el){
                        Func.call({$el: el, settings, id:ID,isLive: true});
                    });
                })();
            